import {
  Button,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay
} from '@chakra-ui/react';
import { FC } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  src: string;
  alt: string;
};

const ImageZoomModal: FC<Props> = ({ isOpen, onClose, src, alt }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay bg="blackAlpha.800" />
      <ModalContent
        bg="transparent"
        boxShadow="none"
        m={0}
        h="100vh"
        display="flex"
        flexDirection="column"
      >
        <ModalBody
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={0}
          flex={1}
          overflow="hidden"
        >
          <TransformWrapper>
            <TransformComponent
              wrapperStyle={{
                width: '100%',
                height: '100%',
                overflow: 'hidden'
              }}
              contentStyle={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Image
                src={src}
                alt={alt}
                maxW="100%"
                maxH="100%"
                objectFit="contain"
              />
            </TransformComponent>
          </TransformWrapper>
        </ModalBody>
        <ModalFooter justifyContent="center" py="1rem">
          <Button variant="primary-fullwidth-rounded" onClick={onClose}>
            閉じる
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ImageZoomModal;
